import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Check, ChevronRight, Zap, Flame, Clock, ShieldCheck, Sparkles } from 'lucide-react';
interface UpsellPurchaseProps {
  spots: number;
  joinedCount: number;
}
export function UpsellPurchase({
  spots,
  joinedCount
}: UpsellPurchaseProps) {
  const [selectedTier, setSelectedTier] = useState(1);
  const [selectedExtraKit, setSelectedExtraKit] = useState('radiestesia');
  const [timeLeft, setTimeLeft] = useState('14:43');
  // Timer logic
  useEffect(() => {
    const timer = setInterval(() => {
      const [mins, secs] = timeLeft.split(':').map(Number);
      if (mins === 0 && secs === 0) return;
      let newMins = mins;
      let newSecs = secs - 1;
      if (newSecs < 0) {
        newMins -= 1;
        newSecs = 59;
      }
      setTimeLeft(`${String(newMins).padStart(2, '0')}:${String(newSecs).padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const tiers = [{
    id: 1,
    title: 'Solo Constelación Familiar Terapéutica',
    price: '19.990',
    oldPrice: '59.900',
    description: 'Guía Constelación Familiar Terapéutica PDF + 5 Bonos',
    badge: null
  }, {
    id: 2,
    title: 'Guía Constelación Familiar + 1 Kit Opcional',
    price: '29.990',
    oldPrice: '79.900',
    description: 'Elegí un kit adicional para complementar tu formación',
    badge: 'MÁS ELEGIDO'
  }, {
    id: 3,
    title: 'PORTAL TERAPÉUTICO COMPLETO ✨',
    price: '39.990',
    oldPrice: '99.990',
    description: 'Acceso total: Constelaciones + Radiestesia + Reiki + Tarot + Todos sus bonos',
    badge: 'MEJOR VALOR 🔥'
  }];
  const extraKits = [{
    id: 'radiestesia',
    name: 'Kit Radiestesia Profesional',
    icon: '⚡'
  }, {
    id: 'constelaciones',
    name: 'Kit Reiki Profesional',
    icon: '🌸'
  }, {
    id: 'tarot',
    name: 'Kit Tarot Terapéutico',
    icon: '🔮'
  }];
  const getTierImage = () => {
    switch (selectedTier) {
      case 1:
        return 'https://cdn.magicpatterns.com/uploads/5VCzCikRCrmivshx868yTg/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
      case 2:
        if (selectedExtraKit === 'constelaciones') {
          return 'https://cdn.magicpatterns.com/uploads/9QYyXAwynRUHkQM3Qc8pQ1/ChatGPT_Image_27_may_2026,_15_37_22.webp';
        }
        if (selectedExtraKit === 'radiestesia') {
          return 'https://cdn.magicpatterns.com/uploads/v6kRZf3jNj4e4TB6hjAK9D/05393dcc-e8a9-4158-8638-bcd33da82c23.webp';
        }
        if (selectedExtraKit === 'tarot') {
          return 'https://cdn.magicpatterns.com/uploads/o2XCPLtjmFwNJTm4HqkEvR/6e7f317b-cb85-4de6-a3fe-bd663b8856bd.webp';
        }
        return 'https://cdn.magicpatterns.com/uploads/8RK1DxmEDW9bikSa4Hmuhy/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
      case 3:
        return 'https://cdn.magicpatterns.com/uploads/urh4QhywUBB2Z3RZL3ii3v/ChatGPT_Image_27_may_2026,_15_23_37.webp';
      default:
        return 'https://cdn.magicpatterns.com/uploads/5VCzCikRCrmivshx868yTg/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
    }
  };
  const handleCheckout = () => {
    let checkoutUrl = '';
    if (selectedTier === 1) {
      checkoutUrl = 'https://codex-labs.shop/cart/43433734733883:1';
    }
    if (selectedTier === 3) {
      checkoutUrl = 'https://codex-labs.shop/cart/43552261701691:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'radiestesia') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553639530555:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'constelaciones') {
      checkoutUrl = 'https://codex-labs.shop/cart/43552280313915:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'tarot') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553649524795:1';
    }
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };
  return <section id="purchase" className="py-20 px-4 bg-[#fdfbf7] pt-[15px] pb-[15px]" data-id="element-211" data-mp="zf2gexisjei9">
      <div className="max-w-[440px] mx-auto bg-white rounded-[3rem] shadow-[0_20px_50px_rgba(124,58,237,0.1)] border border-[#f3e8ff] overflow-hidden" data-id="element-212" data-mp="ugiqyn4znkl5">
        <div className="p-8 text-center pt-[15px] pb-[15px] pl-[10px] pr-[10px]" data-id="element-213" data-mp="phfxlzydf2t0">
          {/* Social Proof Header */}
          <div className="mb-[10px]" data-id="element-214" data-mp="lhxcb32n0ppn">
            <p className="text-[#a78bfa] font-black text-sm tracking-widest uppercase mb-2" data-id="element-215" data-mp="1i63b39cvonw0">
              + {joinedCount} ALUMNOS
            </p>
            <div className="flex justify-center gap-1 text-yellow-400 mb-1" data-id="element-216" data-mp="1d8tqc70fp0ei">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-217" data-mp="14ef059ed85gm" data-mpi={i} />)}
            </div>
            <p className="text-[#a78bfa] text-sm font-bold" data-id="element-218" data-mp="20wb9je5muq5v">(1.728 reseñas)</p>
          </div>

          <div className="inline-block bg-[#fffbeb] text-[#92400e] px-6 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest mb-8 border border-[#fef3c7]" data-id="element-219" data-mp="20y5toq92ye8w">
            ECOSISTEMA TERAPÉUTICO PROFESIONAL
          </div>

          <div className="mb-[10px]" data-id="element-220" data-mp="3jqny03u9r2an">
            <h2 className="text-[#1e1b4b] font-['Playfair_Display',_serif] text-[28px] md:text-[32px] font-bold leading-tight mb-1" data-id="element-221" data-mp="3jrpj71501563">
              Elegí el camino terapéutico
            </h2>
            <span className="text-[#d97706] font-['Dancing_Script',_cursive] block text-[36px] md:text-[42px] leading-none" data-id="element-222" data-mp="3stozfr86w57z">
              que mejor conecte con vos
            </span>
            <div className="flex justify-center mt-4" data-id="element-223" data-mp="6jmhfjkhzht3">
              <Sparkles className="text-[#fbbf24] w-8 h-8 opacity-60" data-id="element-224" data-mp="bbw3goihrxq3" />
            </div>
          </div>

          <p className="text-[#a78bfa] font-medium mb-10 px-8 text-[14px]" data-id="element-225" data-mp="fczi57osznpq">
            Accedé de forma inmediata a nuestros programas terapéuticos
            profesionales con acceso de por vida, material 100% digital en
            formato PDF descargable y futuras actualizaciones incluidas.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-226" data-mp="2le0f8zm306qh">
            <span className="font-black text-[#a78bfa] uppercase tracking-[0.2em] flex gap-2 items-center justify-start text-[11px]" data-id="element-227" data-mp="2gfgvn5uyn71a">
              ↓ SELECCIONÁ EL PACK QUE PREFIERAS: ↓
            </span>
          </div>

          {/* Tiers List */}
          <div className="space-y-4 mb-8" data-id="element-228" data-mp="2qcuz84vsc1c6">
            {tiers.map(tier => <div key={tier.id} className="relative" data-id="element-229" data-mp="3449tj7v57oyj">
                {tier.badge && <div className={`absolute -top-3 right-4 z-10 px-3 py-1 rounded-full text-[9px] font-black text-white uppercase tracking-widest shadow-lg ${tier.id === 2 ? 'bg-orange-500' : 'bg-[#7c3aed]'}`} data-id="element-230" data-mp="303zel5pdho7j">
                    ✦ {tier.badge}
                  </div>}
                <button onClick={() => setSelectedTier(tier.id)} className={`w-full text-left p-5 rounded-2xl border-2 transition-all duration-300 relative overflow-hidden ${selectedTier === tier.id ? 'border-[#7c3aed] bg-[#f5f3ff]/30 shadow-md' : 'border-[#f3e8ff] hover:border-[#ddd6fe] bg-white'}`} data-id="element-231" data-mp="1jpzhs3ltqeoi">
                  <div className="flex items-start gap-4" data-id="element-232" data-mp="3gnx17rfg7j8f">
                    <div className={`mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedTier === tier.id ? 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-233" data-mp="3gndjaapssuue">
                      {selectedTier === tier.id && <Check size={14} strokeWidth={4} data-id="element-234" data-mp="3cjz3nl5rughh" />}
                    </div>
                    <div className="flex-1" data-id="element-235" data-mp="2xr5ltt311o9n">
                      <div className="flex justify-between items-start mb-1" data-id="element-236" data-mp="32n2udd81tqbv">
                        <h3 className={`font-black text-sm uppercase tracking-tight ${selectedTier === tier.id ? 'text-[#7c3aed]' : 'text-blue-950'}`} data-id="element-237" data-mp="vxo7y7oazr6g">
                          {tier.title}
                        </h3>
                        <div className="text-right" data-id="element-238" data-mp="3kucxowxt5sjj">
                          <p className="text-[10px] text-[#a78bfa] line-through font-bold leading-none" data-id="element-239" data-mp="3fui76uhy34z0">
                            ${tier.oldPrice}
                          </p>
                          <p className={`text-lg font-black leading-none ${selectedTier === tier.id ? 'text-[#7c3aed]' : 'text-[#319E0D]'}`} data-id="element-240" data-mp="3645prb5ffrx3">
                            ${tier.price}
                          </p>
                        </div>
                      </div>
                      <p className="text-[11px] text-blue-950/40 font-medium leading-tight" data-id="element-241" data-mp="2s4nuccxmlger">
                        {tier.description}
                      </p>
                    </div>
                  </div>
                </button>

                {/* Extra Kit Selector for Tier 2 */}
                <AnimatePresence data-id="element-242" data-mp="legaix0ta43v">
                  {selectedTier === 2 && tier.id === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-243" data-mp="svwch8qvrejv">
                      <div className="mt-4 p-4 bg-[#f5f3ff]/50 rounded-2xl border-2 border-[#ddd6fe] space-y-2" data-id="element-244" data-mp="ewd6omljkfaq">
                        <p className="text-[10px] font-black text-[#7c3aed] uppercase tracking-widest mb-3" data-id="element-245" data-mp="jvgak3pscfh4">
                          SELECCIONÁ TU KIT ADICIONAL:
                        </p>
                        {extraKits.map(kit => <button key={kit.id} onClick={() => setSelectedExtraKit(kit.id)} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${selectedExtraKit === kit.id ? 'bg-white border-[#7c3aed] shadow-sm text-[#7c3aed]' : 'bg-white/50 border-[#f3e8ff] text-[#a78bfa]'}`} data-id="element-246" data-mp="1vdr2qo2gjhwz">
                            <div className="flex items-center gap-2 text-xs font-bold" data-id="element-247" data-mp="2apxa8a8qel6u">
                              <span data-id="element-248" data-mp="1dzelb3ikx6cc">{kit.icon}</span>
                              {kit.name}
                            </div>
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedExtraKit === kit.id ? 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-249" data-mp="1i1rnxj214o4w">
                              {selectedExtraKit === kit.id && <Check size={10} strokeWidth={4} data-id="element-250" data-mp="2yeq84c8wz343" />}
                            </div>
                          </button>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>

          {/* Mockup Visual */}
          <div className="mb-8 rounded-2xl overflow-hidden shadow-xl border border-[#f3e8ff]" data-id="element-251" data-mp="hzbsa5d3j0nf">
            <AnimatePresence mode="wait" data-id="element-252" data-mp="d11tlks5xhx2">
              <motion.img key={selectedTier} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 1.05
            }} transition={{
              duration: 0.3
            }} src={getTierImage()} alt="Mockup Profesional" className="w-full h-auto" data-id="element-253" data-mp="90880y270f7c" />
            </AnimatePresence>
          </div>

          {/* Pricing Final */}
          <div className="pb-[10px] mb-[0px]" data-id="element-254" data-mp="3ivw1cwiheni2">
            <div className="inline-flex items-center gap-2 bg-[#84cc16] text-white px-6 py-2 rounded-full text-[10px] font-black uppercase tracking-widest mb-4 shadow-lg shadow-[#84cc16]/20" data-id="element-255" data-mp="3nofexth65imv">
              <Zap size={14} fill="currentColor" data-id="element-256" data-mp="3dxues1luk61u" /> 50% OFF HOY
            </div>
            <h4 className="font-black text-blue-950 mb-1 text-[18px]" data-id="element-257" data-mp="3dvrl97lhjusd">
              3 cuotas sin interés de
            </h4>
            <p className="font-black text-[#319E0D] text-[18px]" data-id="element-258" data-mp="ahx4ztrll041">
              $
              {(parseInt(tiers.find(t => t.id === selectedTier)?.price.replace('.', '') || '19990') / 3).toLocaleString('es-AR', {
              maximumFractionDigits: 0
            })}
            </p>
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-[#84cc16] hover:bg-[#74c445] text-white py-6 rounded-3xl shadow-[0_15px_30px_rgba(132,204,22,0.4)] transition-all mb-8 relative overflow-hidden group" data-id="element-259" data-mp="2larnnuji2xlm">
            <span className="relative z-10 text-3xl font-black uppercase italic tracking-tighter" data-id="element-260" data-mp="2ipjxqncc108k">
              ACCEDER AHORA
            </span>
            <motion.div animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12" data-id="element-261" data-mp="1q0lc3g903fyi" />
          </motion.button>

          {/* Footer Urgency */}
          <div className="space-y-[16px]" data-id="element-262" data-mp="178sef8izl6kg">
            <div className="flex items-center justify-center gap-2 text-orange-500 font-bold text-sm" data-id="element-263" data-mp="1780w2zeeh5c4">
              <Flame size={18} fill="currentColor" data-id="element-264" data-mp="agngl479gmgx" />
              ¡Últimos {spots} cupos en oferta!
            </div>

            <div className="flex flex-col items-center gap-2" data-id="element-265" data-mp="jjepaw8r544v">
              <div className="flex items-center gap-2 text-[10px] font-black text-[#a78bfa] uppercase tracking-widest" data-id="element-266" data-mp="jh20bz4kttib">
                <Clock size={14} data-id="element-267" data-mp="t8yaw9nunc3f" />
                LA OFERTA EXPIRA EN:
                <span className="text-[#7c3aed] text-sm ml-2" data-id="element-268" data-mp="t8ohec3limsz">{timeLeft}</span>
              </div>
              <div className="w-full h-2 bg-[#f5f3ff] rounded-full overflow-hidden border border-[#f3e8ff]" data-id="element-269" data-mp="y680bpb8nnr9">
                <motion.div initial={{
                width: '100%'
              }} animate={{
                width: '15%'
              }} transition={{
                duration: 600,
                ease: 'linear'
              }} className="h-full bg-gradient-to-r from-[#a78bfa] to-[#7c3aed]" data-id="element-270" data-mp="127jtu5x8gt4q" />
              </div>
            </div>

            <div className="pt-6 flex items-center justify-center gap-2 text-[#a78bfa] text-[10px] font-bold uppercase tracking-widest" data-id="element-271" data-mp="2wotij8875yp7">
              <ShieldCheck size={14} data-id="element-272" data-mp="2rop4dourhg25" />
              Pago 100% Seguro y Protegido
            </div>
          </div>

          {/* Trust Section */}
          <div className="border-t-2 border-dashed border-blue-50 pt-[0px] mt-[0px] space-y-[5px]" data-id="element-273" data-mp="3kfp9k34twpve">
            <img src="https://cdn.magicpatterns.com/uploads/eU118ieSDgWuz64T6oQtAx/capture_260410_163646.png" alt="Pago Seguro Garantizado" className="w-full h-auto object-contain" data-id="element-274" data-mp="3fg2vjrh6f5lj" />

            <div className="text-center" data-id="element-275" data-mp="36feh4vnvf384">
              <img src="https://cdn.magicpatterns.com/uploads/skccFFLzCHBogMzzjkfEmF/7ef4071d-c511-4325-9d9d-f2158f7b8632.jpg" alt="MercadoLíder Platinum" className="w-full h-auto object-contain shadow-sm rounded-xl" data-id="element-276" data-mp="1z1uh6k6k82kz" />
            </div>

            <div className="bg-blue-50/50 p-4 rounded-2xl border border-blue-100" data-id="element-277" data-mp="21ghmttu43izb">
              <p className="text-blue-950 font-black text-[10px] uppercase tracking-widest mb-3" data-id="element-278" data-mp="1mjieg3rfrm3s">
                Tu Compra está Protegida
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-279" data-mp="1rh0ef4nh6qzn">
                <img src="https://cdn.magicpatterns.com/uploads/7eCtKk7WA3cLyGaeie1cdM/png-clipart-safe-purchase-payment-security-shop-shopping-online-store-e-commerce-sign-green-texta.png" alt="Compra Segura" className="h-10 object-contain" data-id="element-280" data-mp="1dqwx8s3gdnh2" />
                <img src="https://cdn.magicpatterns.com/uploads/fpbSfdYZaTGuGJTHBKUizP/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png" alt="Garantía de 7 Días" className="h-14 object-contain" data-id="element-281" data-mp="18svgwexew29a" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}